import React, { useState } from "react";
import { Modal } from "../../components/admin/Modal";

export const ContactsTab = ({ contacts, onDelete, onMarkAsRead }) => {
  const [viewingContact, setViewingContact] = useState(null);

  return (
    <div className="admin-section ">
      <h2>Contact via formulaire</h2>

      <Modal
        isOpen={!!viewingContact}
        onClose={() => setViewingContact(null)}
        title="Message complet"
      >
        <div style={{ marginBottom: "10px" }}>
          <strong>Nom:</strong> {viewingContact?.nom}
        </div>
        <div style={{ marginBottom: "10px" }}>
          <strong>Email:</strong> {viewingContact?.email}
        </div>
        <div style={{ marginBottom: "10px" }}>
          <strong>Sujet:</strong> {viewingContact?.sujet}
        </div>
        <div style={{ marginBottom: "10px" }}>
          <strong>Date:</strong>{" "}
          {viewingContact?.createdAt
            ? new Date(viewingContact.createdAt).toLocaleDateString()
            : "N/A"}
        </div>
        <div style={{ marginTop: "15px" }}>
          <strong>Message:</strong>
          <div
            style={{
              marginTop: "10px",
              padding: "15px",
              backgroundColor: "white",
              borderRadius: "5px",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
            }}
          >
            {viewingContact?.message}
          </div>
        </div>
      </Modal>

      <div className="table-container">
        <div className="product-admin-table">
          <div className="product-header">
            <div>Nom</div>
            <div>Email</div>
            <div>Sujet</div>
            <div>Message</div>
            <div>Date</div>
            <div>Actions</div>
          </div>
          {[...contacts]
            .sort((a, b) => b.id - a.id)
            .map((contact) => (
              <div className="product-row" key={contact.id}>
                <div className="product-cell">{contact.nom}</div>
                <div className="product-cell">{contact.email}</div>
                <div className="product-cell">{contact.sujet}</div>
                <div className="product-cell description-cell">
                  {contact.message.length > 16 ? (
                    <>
                      {contact.message.substring(0, 16)}...
                      <button
                        onClick={() => setViewingContact(contact)}
                        style={{
                          marginLeft: "5px",
                          color: "#4a90e2",
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                          textDecoration: "underline",
                          fontSize: "12px",
                        }}
                      >
                        voir plus
                      </button>
                    </>
                  ) : (
                    contact.message
                  )}
                </div>
                <div className="product-cell" style={{ whiteSpace: "nowrap" }}>
                  {new Date(contact.createdAt).toLocaleDateString()}
                </div>
                <div className="product-cell admin-actions">
                  <button
                    className={contact.lu ? "btn-success" : "btn-warning"}
                    id="btn-read"
                    onClick={() => onMarkAsRead(contact.id, !contact.lu)}

                  >
                    {contact.lu ? <i className="bi bi-check"></i> : <i className="bi bi-envelope-exclamation"></i>}
                  </button>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};
